/* ============================================================
   KOELER — Scripts front
   Reveal au scroll + sticky add-to-cart + interactions micro
   ============================================================ */

(() => {
  'use strict';

  /* ----- Reveal au scroll (IntersectionObserver) ----- */
  const revealEls = document.querySelectorAll('.koeler-reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    revealEls.forEach((el) => io.observe(el));
  } else {
    // Fallback : on rend tout visible si pas de support
    revealEls.forEach((el) => el.classList.add('is-visible'));
  }

  /* ----- Sticky add-to-cart visibility (page produit) ----- */
  const stickyBar = document.querySelector('[data-koeler-sticky-atc]');
  const stickyAnchor = document.querySelector('[data-koeler-atc-anchor]');
  if (stickyBar && stickyAnchor && 'IntersectionObserver' in window) {
    const ioAtc = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    ioAtc.observe(stickyAnchor);
  }

  /* ----- Accordéons (FAQ produit, ingrédients) ----- */
  document.querySelectorAll('[data-koeler-accordion]').forEach((acc) => {
    const trigger = acc.querySelector('[data-koeler-accordion-trigger]');
    const panel = acc.querySelector('[data-koeler-accordion-panel]');
    if (!trigger || !panel) return;
    trigger.addEventListener('click', () => {
      const isOpen = acc.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', String(isOpen));
      panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : '0px';
    });
  });

  /* ----- Header scrolled state ----- */
  const header = document.querySelector('[data-koeler-header]');
  if (header) {
    let lastY = 0;
    const onScroll = () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 8);
      header.classList.toggle('is-hidden', y > 240 && y > lastY);
      lastY = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();
